// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdParam,
    PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdBody,
    BaseResponseVoid,
} from '../../../../types';

/**
 * 编辑客户画像
 *
 * @export
 * @tags 智能陪练-客户画像配置
 * @link [PUT] /intelligentPartnerCustomerPersonas/manage/roleEnable/{id}
 * @param id
 */
export function putIntelligentPartnerCustomerPersonasManageRoleEnableById(
    data: PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdBody,
    options: ApiOptions<PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdParam, never> & {
        segments: PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<
        PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdBody,
        PutIntelligentPartnerCustomerPersonasManageRoleEnableByIdParam,
        never
    >('/intelligentPartnerCustomerPersonas/manage/roleEnable/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putIntelligentPartnerCustomerPersonasManageRoleEnableById',
    });
}

export const meta = [
    {
        tags: ['智能陪练-客户画像配置'],
        path: '/intelligentPartnerCustomerPersonas/manage/roleEnable/{id}',
        method: 'put',
    },
];
